/* 🤖 this file was generated by svg-to-ts */
export const DfIconCrossCircle12: {
  name: 'cross-circle-12';
  data: string;
} = {
  name: 'cross-circle-12',
  data: `<svg viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0Zm2.758 3.242a.827.827 0 0 0-1.17 0L6 4.831 4.411 3.242a.827.827 0 0 0-1.169 1.17L4.831 6 3.242 7.589a.827.827 0 0 0 1.17 1.169L6 7.169l1.589 1.589a.827.827 0 0 0 1.169-1.17L7.169 6l1.589-1.589a.827.827 0 0 0 0-1.169Z"/></svg>`
};
